import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/user/pl")({
  staticData: { application: "Pricing" },
});
